
const StudyResultsBox = ({boxImage, boxTitle1, boxTitle2 }) => {
    return(
        <div className="st-result-box">
            <div className="st-box">
                <div className="st-icon"><img src={boxImage} height="80" alt="result box"/></div>
                <h5 className="st-title">{boxTitle1}<br />{boxTitle2}</h5>
            </div>
         </div>
    );
    
};
export default StudyResultsBox;
